import React from "react";
import { AthleteReview } from "./athletereview";

export default function ReviewSection({
  hasSubscriptionAccess = true,
  hasUsedFreeTrial = false,
}) {
  return (
    <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
      <div className="w-full">
        <h2 className="text-xl uppercase text-center">
          Review your Trackit experience
        </h2>
        <div className="w-full">
          <AthleteReview
            hasSubscriptionAccess={hasSubscriptionAccess}
            hasUsedFreeTrial={hasUsedFreeTrial}
          />
        </div>
      </div>
    </div>
  );
}
